import { Component, inject } from '@angular/core';
import { AiCreatePostModalService } from '@features/posts/services/ai-create-post-modal.service';

@Component({
  selector: 'app-step-generating',
  standalone: true,
  templateUrl: './step-generating.component.html',
  styleUrl: './step-generating.component.scss',
})
export class StepGeneratingComponent {
  protected readonly service = inject(AiCreatePostModalService);
  protected readonly formData = this.service.formData;
  protected readonly isGenerating = this.service.isGenerating;
  protected readonly generateError = this.service.generateError;

  retry() {
    this.service.generatePosts();
  }

  backToPrompt() {
    this.service.goToStep(1);
  }
}
